import { render } from "./CAlert.vue?vue&type=template&id=34e1ab80"
import script from "./CAlert.vue?vue&type=script&lang=js"
export * from "./CAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__